import React from 'react';
import { IconSingle, Paragraph } from '@trainline/depot-web';
import { css } from 'aphrodite/no-important';
import dayjs from 'dayjs';

import { PaygJourney } from '@contactcentre-web/hooks/api/useFetchJourneys';

import styles from './styles';

interface Props {
  journey: PaygJourney;
}
export const Journey = ({ journey }: Props) => (
  <Paragraph color="subtle" typeStyle="body" className={css(styles.journey)}>
    {journey.legs[0].originStationName}{' '}
    {journey.legs[0].originShortName ? ` (${journey.legs[0].originShortName}) ` : ' '}
    {dayjs(journey.legs[0].actualDepartureDateTime).format('HH:mm')}
    <IconSingle />
    {journey.legs[journey.legs.length - 1].destinationStationName}
    {journey.legs[0].destinationShortName ? ` (${journey.legs[0].destinationShortName}) ` : ' '}
    {dayjs(journey.legs[0].actualArrivalDateTime).format('HH:mm')}
  </Paragraph>
);
